export const ALL_STATES_LABEL_OPTION = 'All states';

export const ALL_YEARS_LABEL_OPTION = 'All years';

export const MONTHS_LABELS = ['All months', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
